"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FilterOptionType = void 0;
let FilterOptionType = exports.FilterOptionType = /*#__PURE__*/ function(FilterOptionType) {
    FilterOptionType["Default"] = "default";
    FilterOptionType["Color"] = "color";
    return FilterOptionType;
}({});
